// extracted by mini-css-extract-plugin
export default {"contactCard":"contactCard--bJvaf","contactCardImageWrapper":"contactCardImageWrapper--bJvaf","heading":"heading--bJvaf","descriptor":"descriptor--bJvaf"};